function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00ff94;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M.249,7.91,5.437,2.722A.786.786,0,0,1,6.549,3.834l-3.9,3.9H12.805a.786.786,0,1,1,0,1.572H2.65L6.5,13.151a.786.786,0,0,1-1.112,1.111L.2,9.075a.75.75,0,0,1-.052-.058.314.314,0,0,1-.021-.028C.116,8.978.106,8.967.1,8.955L.078,8.921C.072,8.91.065,8.9.06,8.889S.048,8.866.043,8.854.031,8.831.027,8.82.018,8.8.014,8.785,0,8.76,0,8.747l-.009-.036c0-.013-.007-.026-.009-.039s0-.028-.007-.042,0-.023-.005-.034a.8.8,0,0,1,0-.155c0-.012,0-.023.005-.034s0-.028.007-.041.006-.026.009-.039L0,8.291c0-.013.008-.024.013-.037a.311.311,0,0,1,.013-.035c0-.012.01-.023.016-.034s.011-.024.017-.036l.019-.032L.1,8.083c.008-.012.017-.023.025-.034s.013-.019.021-.028a.76.76,0,0,1,.081-.083c.008-.01.016-.019.024-.028",
  transform: "translate(0.033 -2.493)"
});

var SvgBackArrow = function SvgBackArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.625,
    height: 12,
    viewBox: "0 0 13.625 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-arrow.22b62f00.svg";
export { ForwardRef as ReactComponent };